import PropTypes from "prop-types";
import React, {useEffect, useState} from 'react';

import Modal from "../titled-modal/titled-modal.jsx";
import Box from '../box/box.jsx';
import Input from '../forms/input.jsx';
import Button from '../button/button.jsx';
import styles from './dropdown.css';

// 下拉框选项内容最大长度
const OPTION_TEXT_MAX_LENGTH = 50;
// 下拉框选项最大数量
const OPTION_MAX_COUNT = 50;

const DropdownConfig = (props) => {
  const [options, setOptions] = useState([]);
  const disabled = options.length >= OPTION_MAX_COUNT;

  useEffect(() => {
    const len = props.options ? props.options.length : 0;
    // 如果传入的选项为空，则默认添加一个空白选项
    setOptions(len ? props.options : [''])
  }, [props.options])

  const handleAddOption = () => {
    setOptions([...options, '']);
  }

  const handleRemoveOption = (idx) => {
    setOptions(options.filter((_, index) => index !== idx));
  }

  const handleOptionChange = (idx, value) => {
    const newOptions = [...options];
    newOptions[idx] = value;
    setOptions(newOptions);
  }

  const handleClose = () => {
    // 去除空白选项、重复选项
    const uniqueOptions = Array.from(new Set(options.map(opt => opt.trim()).filter(opt => opt)));
    props.onClose(uniqueOptions);
  }

  if (!props.visible) {
    return null;
  }

  return (
      <Modal overlayClassName={styles.modal} contentLabel="编辑下拉框选项" onRequestClose={handleClose}>
          <div className={styles.container}>
            {
              options.map((item, idx) => (
                <Box className={styles.option} flex>
                  <div className={styles.label}>{`选项 ${idx + 1}`}</div>
                  <Input className={styles.input} maxLength={OPTION_TEXT_MAX_LENGTH} value={item} onChange={(e) => handleOptionChange(idx, e.target.value)} />
                  <Button className={styles.removeButton} onClick={() => handleRemoveOption(idx)}>删除</Button>
                </Box>
              ))
            }

            <Button disabled={disabled} className={styles.addButton} onClick={handleAddOption}>+ 添加选项</Button>
          </div>
      </Modal>
  );
};

DropdownConfig.propTypes = {
  visible: PropTypes.bool,
  options: PropTypes.array,
  onClose: PropTypes.func,
};

export default DropdownConfig;